import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public winners status — lets the home page swap "Winners announced on 8th
// October" for "Winners announced" the moment admins flip the switch.
export const useWinnersStatus = () => {
  const [announced, setAnnounced] = useState(false);
  useEffect(() => {
    axios.get(`${API}/winners`).then((r) => setAnnounced(!!(r.data?.announced && r.data.winners?.length))).catch(() => {});
  }, []);
  return announced;
};

export default useWinnersStatus;
